import "core-js/modules/es.array.index-of";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "regenerator-runtime/runtime";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */

/* eslint-disable wf-security/no-location-href */
import { call, take, put, select } from 'redux-saga/effects';
import { go } from 'connected-react-router';
import { waitUntil, modalCloses } from 'wfui-digital-core/es/lib';
import removeLogoffPrompt from '../../remove-logoff-prompt/remove-logoff-prompt';
import routeNavigation from '../../navigation/route-navigation';
import NavigationItemRecord from '../../records/NavigationItemRecord';
import logger from '../../logger/logger';
import * as actions from './actions';
import { getNavigation, getNavigationItem } from '../selectors';
import { pushLogoffPrompt, failedNavigation } from '../navigation/actions';
import confirmAppNavigation from '../../confirm-app-navigation/confirm-app-navigation';
export var watchNavigationRequest = /*#__PURE__*/regeneratorRuntime.mark(function watchNavigationRequest() {
  var _yield$take, navigationItem;

  return regeneratorRuntime.wrap(function watchNavigationRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 15;
            break;
          }

          _context.next = 3;
          return take(actions.NAVIGATION_REQUEST_NAVIGATION);

        case 3:
          _yield$take = _context.sent;
          navigationItem = _yield$take.navigationItem;
          logger.debug("Navigation saga: requestNavigation - ".concat(navigationItem.linkId || navigationItem.navigationUrl));

          if (!navigationItem.waitForModalToClose) {
            _context.next = 9;
            break;
          }

          _context.next = 9;
          return waitUntil(modalCloses, 100, 10, 100);

        case 9:
          _context.next = 11;
          return put(actions.setNavigationItem(navigationItem));

        case 11:
          _context.next = 13;
          return put(actions.navigate());

        case 13:
          _context.next = 0;
          break;

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, watchNavigationRequest);
});
export var watchNavigationRequestWithId = /*#__PURE__*/regeneratorRuntime.mark(function watchNavigationRequestWithId() {
  var _yield$take2, navigationItemId, navigationItem;

  return regeneratorRuntime.wrap(function watchNavigationRequestWithId$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!true) {
            _context2.next = 18;
            break;
          }

          _context2.next = 3;
          return take(actions.NAVIGATION_REQUEST_NAVIGATION_WITH_ID);

        case 3:
          _yield$take2 = _context2.sent;
          navigationItemId = _yield$take2.navigationItemId;
          _context2.next = 7;
          return select(getNavigationItem, navigationItemId);

        case 7:
          navigationItem = _context2.sent;

          if (!navigationItem) {
            _context2.next = 13;
            break;
          }

          _context2.next = 11;
          return put(actions.requestNavigation(navigationItem));

        case 11:
          _context2.next = 16;
          break;

        case 13:
          logger.error('Navigation Item not found for id', navigationItemId);
          _context2.next = 16;
          return put(failedNavigation({
            errorType: 'NavigationError',
            errorMessage: 'Navigation Item not found for id'
          }));

        case 16:
          _context2.next = 0;
          break;

        case 18:
        case "end":
          return _context2.stop();
      }
    }
  }, watchNavigationRequestWithId);
});
export var watchNavigationRequestSamlBack = /*#__PURE__*/regeneratorRuntime.mark(function watchNavigationRequestSamlBack() {
  var _yield$take3, _yield$take3$payload, backNavigationUrl, history, navigationItem, path;

  return regeneratorRuntime.wrap(function watchNavigationRequestSamlBack$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (!true) {
            _context3.next = 18;
            break;
          }

          _context3.next = 3;
          return take(actions.NAVIGATION_REQUEST_SAML_BACK);

        case 3:
          _yield$take3 = _context3.sent;
          _yield$take3$payload = _yield$take3.payload;
          backNavigationUrl = _yield$take3$payload.backNavigationUrl;
          history = _yield$take3$payload.history;
          logger.debug("Navigation saga: requestSamlNavigationBack for ".concat(backNavigationUrl));
          navigationItem = new NavigationItemRecord({
            samlNavigation: true,
            useContext: true,
            navigationUrl: backNavigationUrl.replace(/^\//, ''),
            displayType: 'saml'
          });
          path = removeLogoffPrompt(history.location.pathname);
          _context3.next = 12;
          return put(pushLogoffPrompt(path));

        case 12:
          _context3.next = 14;
          return waitUntil(function () {
            return window.location.hash.indexOf('promptLogoff') === -1;
          }, 100, 10);

        case 14:
          _context3.next = 16;
          return put(actions.requestNavigation(navigationItem));

        case 16:
          _context3.next = 0;
          break;

        case 18:
        case "end":
          return _context3.stop();
      }
    }
  }, watchNavigationRequestSamlBack);
});
export var watchNavigation = /*#__PURE__*/regeneratorRuntime.mark(function watchNavigation() {
  var navigation, failureReason;
  return regeneratorRuntime.wrap(function watchNavigation$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (!true) {
            _context4.next = 21;
            break;
          }

          _context4.next = 3;
          return take(actions.NAVIGATION_NAVIGATE);

        case 3:
          _context4.next = 5;
          return put(actions.hideConfirmation());

        case 5:
          _context4.next = 7;
          return select(getNavigation);

        case 7:
          navigation = _context4.sent;
          _context4.prev = 8;
          _context4.next = 11;
          return call(confirmAppNavigation, navigation.toJS());

        case 11:
          _context4.next = 13;
          return call(routeNavigation, navigation.toJS());

        case 13:
          _context4.next = 19;
          break;

        case 15:
          _context4.prev = 15;
          _context4.t0 = _context4["catch"](8);
          failureReason = _context4.t0.failureReason;
          logger.debug(failureReason);

        case 19:
          _context4.next = 0;
          break;

        case 21:
        case "end":
          return _context4.stop();
      }
    }
  }, watchNavigation, null, [[8, 15]]);
});
export var watchNavigateBack = /*#__PURE__*/regeneratorRuntime.mark(function watchNavigateBack() {
  var _yield$take4, _yield$take4$location, locations;

  return regeneratorRuntime.wrap(function watchNavigateBack$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (!true) {
            _context5.next = 10;
            break;
          }

          _context5.next = 3;
          return take(actions.NAVIGATION_NAVIGATE_BACK);

        case 3:
          _yield$take4 = _context5.sent;
          _yield$take4$location = _yield$take4.locations;
          locations = _yield$take4$location === void 0 ? 1 : _yield$take4$location;
          _context5.next = 8;
          return put(go(locations * -1));

        case 8:
          _context5.next = 0;
          break;

        case 10:
        case "end":
          return _context5.stop();
      }
    }
  }, watchNavigateBack);
});